import React, { useEffect, useState, useRef } from "react"
import { apiEndpoint } from "helpers/url_helper";
import jsPDF from "jspdf";
import "jspdf-autotable";
import MetaTags from 'react-meta-tags';
import Select from "react-select";
import moment from "moment";
import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    ButtonGroup,
    UncontrolledTooltip,
    Spinner
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next"
// import 'assets/scss/custom/pages/common.scss';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
//import ReactToPrint from "react-to-print";
const { SearchBar } = Search;
import ReactBSAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import paginationFactory from 'react-bootstrap-table2-paginator';

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import ViewImageModalComponent from './ViewImageModal';
import EditViolationModalComponent from './EditViolationModal'
import { ReportType, SearchData, SpeedType, ViolationType } from './ViolationLogsComponents';

import { ViolationsContext } from "components/Common/PageDataContext";

import getCurrentDate from "components/Common/Utility"

import jwt from "jsonwebtoken";

//Style
const btnstylesObj = {
    "margin-top": '2rem',
};

const btnRadiostylesObj = {
    "margin-top": '2.5rem',
    marginLeft:"2%"
};


// This is  custom csv export component
const ExportCSV = (props) => {
    const handleClick = () => {
        props.onExport();
    };
    return (
        <Button size="sm" id="csv-tooltip"
            className="buttons-copy buttons-html5"
            color="dark" onClick={handleClick}>
            <span>CSV</span></Button>
    );
};

const ViolationsReport = (props) => {
    //Print function
    const componentRef = useRef();
    const [Campusitems, setCampusItems] = useState([]);
    const [SelectedCampusitem, setSelectedCampusItem] = useState([]);
    const [selectedCampusVal, setCampusSelected] = useState();

    const [FromDtTm, setFrmDttm] = useState(moment().format("YYYY-MM-DD 00:00"));
    const [ToDtTm, setToDttm] = useState(moment().format("YYYY-MM-DD HH:mm"));
    const [Monthlyrt, setMonthlyrt] = useState(moment().format("YYYY-MM"));

    const [FromSpeed, setFrmSpeed] = useState(20);
    const [ToSpeed, setToSpeed] = useState(100);
    const [BoolANPR, setANPR] = useState(true);
    const [RegisteredVehicleFlag, setRegisteredVehicleFlag] = useState(true);


    const [selectedReportTypeVal, setReportType] = useState(1);
    const [selectedSpeedTypeVal, setSpeedType] = useState(1);
    const [selectedViolationTypeVal, setViolationType] = useState(0);

    const [selectonLoadLocVal, setselectonLoadLocVal] = useState();

    const [editviolations, seteditviolations] = useState();

    const [speedLimit, setspeedLimit] = useState(true);
    const [vehicleOwner, setvehicleOwner] = useState(true);
    const [ownerEmail, setownerEmail] = useState(true);
    const [ownerNo, setownerNo] = useState(true);
    const [ownerDept, setownerDept] = useState(true);
    const [empID, setempID] = useState(true);
    const [violationFreq, setviolationFreq] = useState(true);

    const [violationsForExport, setviolationsForExport] = useState([]);
    const [headers, setheaders] = useState([]);

    const [isLoading, setIsLoading] = useState(false);



    var today = new Date();
    var datefilename = getCurrentDate() + '_ViolationsReport.csv';

    const SearchViolations = () => {
        // useEffect(() => {
            setIsLoading(true);
        console.log(selectedViolationTypeVal)
        if (ToSpeed >= 1 && FromSpeed >= 1) {
            // UserValidated
            fetch(apiEndpoint + "/GetViolationLogs",
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "intCampusID": selectedCampusVal,// 1,
                        "intLocationID": selectedLocVal,//1,
                        "intReportType": selectedReportTypeVal,//1,
                        "FromDtTm": FromDtTm,
                        "ToDtTm": ToDtTm,
                        "MonthlyRt": Monthlyrt,
                        "intSpeedType": selectedSpeedTypeVal,//1,
                        "FromSpeed": FromSpeed,
                        "ToSpeed": ToSpeed,
                        "boolOnlyANPR": BoolANPR,
                        "boolRegisteredVehicle": RegisteredVehicleFlag,
                        "ViolationType": selectedViolationTypeVal,
                        "strToken": sessionStorage.getItem("Clear_AuthUser")
                    })
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result != undefined) {
                            //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                            //console.log(result);
                            if (JSON.parse(result.Violations).length > 0){
                                setViolations(JSON.parse(result.Violations));
                                setIsLoading(false);
                            }
                            else{
                                setViolations([]);
                                setIsLoading(false);

                                setAlert(
                                    <ReactBSAlert
                                    warning
                                        //   style={bsAlertStyle}
                                        //   title="Good job!"
                                        onConfirm={() => setAlert(null)}
                                        onCancel={() => setAlert(null)}
                                        confirmBtnBsStyle="info"
                                    >
                                      No data found!
                                    </ReactBSAlert>
                                )
                            }
                        }
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        //setError(error);
                    }
                )

        }
        var dataArr = [];
        var headersArr = [];

        for (var i = 0; i < componentRef.current.table.props.columns.length; i++) {
            headersArr.push(componentRef.current.table.props.columns[i])
        }
        console.log(headersArr)
        if(violations!=null){
            
        for (var i = 0; i < violations.length; i++) {
            var arr=[];
            for (var k = 0; k <componentRef.current.table.props.columns.length; k++) {
                var field=componentRef.current.table.props.columns[k].dataField
               // console.log(field)
                arr.push((violations[i])[''+field+''])
            }
            dataArr.push(arr);
            arr=[]
        }
        setviolationsForExport(dataArr)
    }
    else{
        setviolationsForExport(violations)
    }
setheaders(headersArr)
        // }, [violations])
    }
    const exportPDF = () => {
        const unit = "pt";
        const size = "A2"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(14);
        // doc.autoTable({headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [231, 215, 252]} }); 
        const title = "Violations Report";
        //   const headers = [["Record ID","Campus Name", "Location Name","Incident Time","Type Of Violation","Registration Number","Speed of Offence",
        // "Speed Limit","Employee ID","Vehicle Owner","Owner Contact","Owner Email","Owner Dept"]];
        console.log(componentRef.current)
        const data1 = violations.map(log => [log.RecordID, log.CampusName, log.LocationName, log.IncidentTime,
        log.TypeOfViolation, log.RegistrationNumber, log.VehicleSpeed, log.SpeedLimit, log.EmployeeID,
        log.VehicleOwnerName, log.VehicleOwnerContact, log.VehicleOwnerEmailAddress, log.VehicleOwnerDept]);

        console.log(componentRef.current.table.props.columns)

        var headersArr = [];
        var dataArr = [];

        for (var i = 0; i < componentRef.current.table.props.columns.length; i++) {
            headersArr.push(componentRef.current.table.props.columns[i].text)
        }
        for (var i = 0; i < violations.length; i++) {
            var arr=[];
            for (var k = 0; k <componentRef.current.table.props.columns.length; k++) {
                var field=componentRef.current.table.props.columns[k].dataField
               // console.log(field)
                arr.push((violations[i])[''+field+''])
            }
            dataArr.push(arr);
            arr=[]
        }

        
        const headers = [headersArr];
        const data=dataArr;
        setviolationsForExport(dataArr)
        console.log(data)
        console.log(data1)
        console.log(dataArr)

        let content = {
            startY: 50,
            head: headers,
            body: data
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        
        doc.save(getCurrentDate() + '_ViolationsReport.pdf')
    }

    const DisablePrintCol = () => {
        debugger;
        const DisblePrintColumn = document.getElementById('DisbalePrint');
        if (DisblePrintCol) {
            DisablePrintColumn.style.display = "none";
        }

    }
    const breadcrumbItems = [

        //  { title: "Violation Logs", link: "/ViolationLogs" },
    ]
    const [violations, setViolations] = useState([]);
    const Contextvalue = { violations, setViolations };
    const [alertmsg, setAlert] = useState([]);

    const columns = [
        {
            dataField: "RecordID",
            text: "RecordID",
            hidden: true,
            csvExport :false,
        },
        {
            dataField: "CampusName",
            text: "Campus Name",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '125px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },

        {
            dataField: "LocationName",
            text: "Location Name",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return {width: '120px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },

        {
            dataField: "IncidentTime",
            text: "Incident Datetime",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return {width: '120px',  textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },
        {
            dataField: "TypeOfViolation",
            text: "Event Type",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return {width: '90px',   textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }


        },
        {
            dataField: "RegistrationNumber",
            text: "Registration Number",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '140px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },
        // {
        //     dataField: "LaneNumber",
        //     text: "Lane Number",
        //     sort: true
        // },
        {
            dataField: "VehicleSpeed",
            text: "Speed of Offence",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return {width: '110px',  textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },
        {
            dataField: "SpeedLimit",
            text: "Speed Limit",
            hiddenWhenPrint: true,
            hidden: !speedLimit,
            csvExport: speedLimit,
            headerStyle: (colum, colIndex) => {
                return {width: '100px',  textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }

        },
        {
            dataField: "EmployeeID",
            text: "Employee ID",
            hidden: !empID,
            csvExport : empID,
            sort: true,
            headerStyle: (colum, colIndex) => {
                return {width: '100px',   textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },
        {
            dataField: "VehicleOwnerName",
            text: "Vehicle Owner",
            hidden: !vehicleOwner,
            csvExport : vehicleOwner,
            sort: true,
            headerStyle: (colum, colIndex) => {
                return {width: '100px',  textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },
        {
            dataField: "VehicleOwnerContact",
            text: "Owner Contact",
            hidden: !ownerNo,
            csvExport: ownerNo,
            sort: true,
            headerStyle: (colum, colIndex) => {
                return {width: '110px',  textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },
        {
            dataField: "VehicleOwnerEmailAddress",
            text: "Owner Email",
            hidden: !ownerEmail,
            csvExport: ownerEmail,
            
            headerStyle: (colum, colIndex) => {
                return {width: '100px',  textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },
        {
            dataField: "VehicleOwnerDept",
            text: "Owner Dept",
            hidden: !ownerDept,
            csvExport: ownerDept,
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '100px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },
        {
            dataField: "TotalViolationFrequency",
            text: "Violation Frequency",
            hidden: !violationFreq,
            csvExport: violationFreq,
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '120px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              }
        },
        
    ]

    const custompagination = paginationFactory({
        page: 2,
        sizePerPage: 10,
        lastPageText: '>>',
        firstPageText: '<<',
        nextPageText: '>',
        prePageText: '<',
        showTotal: true,
        alwaysShowAllBtns: true,
        //all option for pagination
        paginationSize: 3,
        sizePerPageList: [{
            text: '10', value: 10
        },
        {
            text: '50', value: 50
        },
        {
            text: '100', value: 100
        }, {
            text: 'All', value: violations.length
        }],
        onPageChange: function (page, sizePerPage) {
            console.log('page', page);
            console.log('sizePerPage', sizePerPage);
        },
        onSizePerPageChange: function (page, sizePerPage) {
            console.log('page', page);
            console.log('sizePerPage', sizePerPage);
        }
    });
    const defaultSorted = [{
        dataField: 'IncidentTime',
        order: 'desc'
    }];

    // Note: the empty deps array [] means
    // this useEffect will run once
    // similar to componentDidMount()

    const ViolationLogsOnPageLoad = (LocValue) => {
        // UserValidated
        fetch(apiEndpoint + "/GetViolationLogs",
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "intCampusID": selectedCampusVal,// 1,
                    "intLocationID": LocValue,//1,
                    "intReportType": selectedReportTypeVal,//1,
                    "FromDtTm": FromDtTm,
                    "ToDtTm": ToDtTm,
                    "MonthlyRt": Monthlyrt,
                    "intSpeedType": selectedSpeedTypeVal,//1,
                    "FromSpeed": FromSpeed,
                    "ToSpeed": ToSpeed,
                    "boolOnlyANPR": BoolANPR,
                    "boolRegisteredVehicle": RegisteredVehicleFlag,
                    "ViolationType": selectedViolationTypeVal,
                    "strToken": sessionStorage.getItem("Clear_AuthUser")
                })
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result != undefined) {
                        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                        //console.log(result);
                        if (JSON.parse(result.Violations).length > 0)
                            setViolations(JSON.parse(result.Violations));
                            else{
                                setViolations([]);
                                setAlert(
                                    <ReactBSAlert
                                        warning
                                        //   style={bsAlertStyle}
                                        //   title="Good job!"
                                        onConfirm={() => setAlert(null)}
                                        onCancel={() => setAlert(null)}
                                        confirmBtnBsStyle="info"
                                    >
                                      No data found!
                                    </ReactBSAlert>
                                )
                            }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //setError(error);
                }
            )
    }

    useEffect(() => {

        const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
        var UserPermissions=JSON.parse(decodedToken.userRolePermissions);
        // var UserPermissions = JSON.parse(sessionStorage.getItem("UserRolePermissions"));
        seteditviolations(UserPermissions.EditViolations)

// UserValidated
fetch(apiEndpoint+"/GetLogCampusList",
   {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "strToken": sessionStorage.getItem("Clear_AuthUser"),
      
    })
  })            .
  then(res => res.json())
            .then(
                (result) => {
                    if (result != undefined) {
                        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                        if (result.CampusList != undefined) {
                            setCampusItems(JSON.parse(result.CampusList));
                            var campuslst = JSON.parse(result.CampusList);
                            setSelectedCampusItem(campuslst[0]);
                            setCampusSelected(campuslst[0].value);
                            changeCampusSelectHandler(campuslst[0])
                        }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )

    }, [])

    const [Locitems, setLocItems] = useState([]);
    const [SelectedLocitem, setSelectedLocItem] = useState([]);
    const [selectedLocVal, setLocSelected] = useState();


    useEffect(() => {
        debugger;
        // UserValidated
        fetch(apiEndpoint + "/GetLogLocationList",
            {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  "strToken": sessionStorage.getItem("Clear_AuthUser"),
                  "intCampusID":selectedCampusVal
                  
                })
              })   
            .then(res => res.json())
            .then(
                (result) => {
                    if (result != undefined) {
                     //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                        if (result.Locations != undefined && result.Locations != 'null') {
                            console.log(result.Locations)
                            var locArr = JSON.parse(result.Locations);
                            locArr.unshift({ "value": 0, "label": "All" })
                            setLocItems(locArr);

                            var loclst = locArr;
                            setSelectedLocItem(loclst[0]);
                            setLocSelected(loclst[0].value);
                            setselectonLoadLocVal(loclst[0].value);
                            ViolationLogsOnPageLoad(loclst[0].value);


                        }
                        else{
                            var locArr=[];
                            setLocItems(locArr);
                            setSelectedLocItem();
                            setLocSelected();
                        }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )
    }, [selectedCampusVal])

    const changeCampusSelectHandler = (event) => {
        setSelectedCampusItem(event);
        setCampusSelected(event.value);

    };

    const changeLocSelectHandler = (event) => {
        setSelectedLocItem(event);
        setLocSelected(event.value);



    };

    const changeReportTypeHandle = () => {
        debugger;


    }

    const changeFrmSpeedHandler = (value, ctx) => {
        if (value > parseInt(ToSpeed)) {
            return "Enter Valid From Speed Value!!";
        }
        return true;
    }

    const changeToSpeedHandler = (value, ctx) => {
        if (value < parseInt(FromSpeed)) {
            return "Enter Valid To Speed Value!!";
        }
        return true;
    }

    const changeMonthHandler = (value, ctx) =>{
        debugger;
      let Year = value.split('-');
      if(Year[0] < 2020)
      {
        return "No Data Available";
      }
      console.log(value);
  
        return true;  
  
      }

    const changeFrmDateHandler = (value, ctx) => {
        //  console.log(value);
        if (value > ToDtTm) {
            return "From date cannot be greater than To date!!!";
        }
        return true;
    }

    const changeToDateHandler = (value, ctx) => {
        if (value < FromDtTm) {
            return "To date cannot be lesser than From date!!!";
        }
        return true;
    }


    //SearchViolations();

    // this function will copy to clipboard an entire table,
    // so you can paste it inside an excel or csv file
    const copyToClipboardAsTable = el => {
        var body = document.body,
            range,
            sel;
        if (document.createRange && window.getSelection) {
            range = document.createRange();
            sel = window.getSelection();
            sel.removeAllRanges();
            try {
                range.selectNodeContents(el);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(el);
                sel.addRange(range);
            }
            document.execCommand("copy");
        } else if (body.createTextRange) {
            range = body.createTextRange();
            range.moveToElementText(el);
            range.select();
            range.execCommand("Copy");
        }

        setAlert(
            <ReactBSAlert
                success
                //   style={bsAlertStyle}
                //   title="Good job!"
                onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="info"
            >
                Copied to clipboard!
            </ReactBSAlert>
        )
    }
    useEffect(() => {
        props.setBreadcrumbItems('Violations Report', breadcrumbItems);
        //  SearchViolations();
    })
    return (
        <React.Fragment>

            <MetaTags>
                <title>Indus | Violations Report</title>
            </MetaTags>
            <AvForm className="needs-validation">
                <Row>
                    <Col md={2}>
                        <label className="mt-1" > Campus  </label>
                        <Select value={SelectedCampusitem} options={Campusitems} onChange={changeCampusSelectHandler}></Select>
                    </Col>
                    <Col md={2}>
                        <label className="mt-1" > Location  </label>
                        <Select value={SelectedLocitem} options={Locitems} onChange={changeLocSelectHandler}></Select>
                    </Col>
                    <Col md={2} sm={2}>
                        <label className="mt-1" > Event Type  </label>
                        <ViolationType setViolationType={setViolationType}

                        ></ViolationType>
                    </Col>
                    <Col md={1}lg={1} sm={3}>
                        <div
                            className="form-check form-switch form-switch-sm mb-3" style={btnRadiostylesObj}
                        >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsizelg"
                                defaultChecked
                                onChange={(event) => setANPR(event.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="customSwitchsizelg"
                            >ANPR
                                
                            </label>
                        </div>
                    </Col>

                    <Col md={2}lg={2} sm={3} >
                        <div
                            className="form-check form-switch form-switch-sm mb-3" style={btnRadiostylesObj}
                        >
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="customSwitchsize"
                                defaultChecked
                                onChange={(event) => setRegisteredVehicleFlag(event.target.checked)}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="customSwitchsize"
                                
                            >
                                Registered Vehicles
                            </label>
                        </div>
                    </Col>
                    <Col md={2}>
                        <Link className="btn btn-md btn-primary waves-effect waves-light" style={btnstylesObj}
                            to="#" role="Button" onClick={SearchViolations} >Search</Link>
                    </Col>



                </Row>
                <Row>

                    <Col md={2} >

                        <label className="mt-1" > Report Type  </label>

                        <ReportType setReportType={setReportType}
                            onChange={() => changeReportTypeHandle}
                        ></ReportType>
                    </Col>

                    <Col sm={2} className="monthlyrt" style={{ display: "none" }}>
                    <label className="form-label mt-1"> Month  </label>
                    <AvField
                    name="monthrt"
                        type="month"
                        validate={{myValidation: changeMonthHandler}}
                        className="form-control"
                        defaultValue={Monthlyrt}
                        id="monthlyrt-input" 
                        onChange={(event) => setMonthlyrt(event.target.value)}

                      />
                  
                </Col>


                    <Col md={2} sm={2}lg={2} className="customdttm" style={{ display: "none" }}>
                        <label className="form-label mt-1"> From  </label>
                        <AvField
                            name="frmdttm"
                            type="datetime-local"
                            validate={{ myValidation: changeFrmDateHandler }}
                            className="form-control"
                            defaultValue={FromDtTm}
                            id="from-datetime-local-input"
                            onChange={(event) => setFrmDttm(event.target.value)}
                        />
                        {/* <input className="form-control" type="datetime-local" defaultValue={FromDtTm}
                        id="from-datetime-local-input" 
                        onChange={(event) => setFrmDttm(event.target.value)} /> */}
                    </Col>
                    <Col md={2} sm={2} lg={2} className="customdttm" style={{ display: "none" }}>

                        <label className="form-label mt-1" > To  </label>
                        <AvField
                            name="todttm"
                            type="datetime-local"
                            validate={{ myValidation: changeToDateHandler }}
                            className="form-control"
                            defaultValue={ToDtTm}
                            id="to-datetime-local-input"
                            onChange={(event) => setToDttm(event.target.value)}
                        />
                        {/* <input className="form-control" type="datetime-local" defaultValue={ToDtTm}
                        id="to-datetime-local-input" onChange={(event) => setToDttm(event.target.value)} /> */}
                    </Col>
                    <Col md={2}>
                        <label className="mt-1" > Speed Range  </label>
                        <SpeedType setSpeedType={setSpeedType}></SpeedType>
                    </Col>
                   
                    <Col md={2} className="customspeed" style={{ display: "none" }}>
                        <label className="form-label mt-1"> From  </label>
                        <AvField
                            name="fromspeed"
                            placeholder="From Speed"
                            type="number"
                            errorMessage="Enter From Speed Value"
                            validate={{ myValidation: changeFrmSpeedHandler }}
                            className="form-control"
                            defaultValue={FromSpeed}
                            id="from-speed"
                            onChange={(event) => setFrmSpeed(event.target.value)}
                        />
                    </Col>
                    <Col md={2} className="customspeed" style={{ display: "none" }}>
                        <label className="form-label mt-1"> To  </label>
                        <AvField
                            name="tospeed"
                            placeholder="To Speed"
                            type="number"
                            errorMessage="Enter To Speed Value"
                            validate={{ myValidation: changeToSpeedHandler }}
                            className="form-control"
                            defaultValue={ToSpeed}
                            id="from-speed"
                            onChange={(event) => setToSpeed(event.target.value)}
                        />
                    </Col>
                    

                </Row>


                <Row>


                </Row>
                <br></br>

                <Card>
                    <CardBody>
                        <Row>
                            <Col md={2}>
                                <div className="form-check form-check-left">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        defaultChecked
                                        onChange={(event) => setempID(event.target.checked)}
                                    />
                                    <label
                                        className="form-check-label"
                                    >Employee ID
                                    </label>
                                </div>
                            </Col>

                            <Col md={2}>
                                <div className="form-check form-check-left">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="customCheck2"
                                        defaultChecked
                                        onChange={(event) => setvehicleOwner(event.target.checked)}
                                    />
                                    <label
                                        className="form-check-label"
                                    >Vehicle Owner
                                    </label>
                                </div>
                            </Col>
                            <Col md={2}>
                                <div className="form-check form-check-left">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        defaultChecked
                                        onChange={(event) => setownerNo(event.target.checked)}
                                    />
                                    <label
                                        className="form-check-label"
                                    >Owner Contact
                                    </label>
                                </div>
                            </Col>

                            <Col md={2}>
                                <div className="form-check form-check-left">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        defaultChecked
                                        onChange={(event) => setownerEmail(event.target.checked)}
                                    />
                                    <label
                                        className="form-check-label"
                                    >Owner Email
                                    </label>
                                </div>
                            </Col>
                          
                        </Row>
                        <br></br>
                        <Row>
                        <Col md={2}>
                                <div className="form-check form-check-left">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        defaultChecked
                                        onChange={(event) => setownerDept(event.target.checked)
                                        }
                                    />
                                    <h6
                                        className="form-check-label"
                                    >Owner Department
                                    </h6>
                                </div>
                            </Col>
                            <Col md={2}>
                                <div className="form-check form-check-left">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        defaultChecked
                                        onChange={(event) => setspeedLimit(event.target.checked)}
                                    />
                                    <label
                                        className="form-check-label"
                                    > Speed Limit
                                    </label>
                                </div>
                            </Col>
                            <Col md={2}>
                                <div className="form-check form-check-left">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        defaultChecked
                                        onChange={(event) => setviolationFreq(event.target.checked)}
                                    />
                                    <label
                                        className="form-check-label"
                                    > Violation Frequency
                                    </label>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

            </AvForm>
            <Row className="mt-3">
                <Col>
                    <Card >
                        <CardBody>

                            <div className="table-responsive mt-2">
                                {alertmsg
                                }

                                <ToolkitProvider
                                    keyField="RecordID"
                                    data={violations}
                                    columns={columns}
                                    exportCSV={{
                                        fileName: datefilename,
                                        // fileName: "ViolationLog.csv",
                                       // onlyExportSelection :true
                                    }}
                                    search
                                >
                                    {
                                        props => (
                                            <div>
                                                <Row>
                                                    <Col xs={12} sm={4}>
                                                        <ButtonGroup>
                                                            <ExportCSV {...props.csvProps} />
                                                            &nbsp;  
                                                            <Button className="buttons-pdf buttons-html5"
                                                                color="dark" id="pdf-tooltip"
                                                                size="sm" onClick={() => exportPDF()}>PDF</Button>
                                                            &nbsp;  
                                                            <Button
                                                                className="buttons-copy buttons-html5"
                                                                color="dark"
                                                                size="sm"
                                                                id="copy-tooltip"
                                                                onClick={() =>
                                                                    copyToClipboardAsTable(
                                                                        document.getElementById("react-bs-table")
                                                                    )
                                                                }
                                                            >
                                                                <span>Copy</span>
                                                            </Button>

                                                            {/* <ReactToPrint
                                                                trigger={() => (
                                                                    <Button
                                                                        color="dark"
                                                                        size="sm"
                                                                        className="buttons-copy buttons-html5"
                                                                        id="print-tooltip"

                                                                    >
                                                                        <span>Print</span>
                                                                    </Button>
                                                                )}
                                                                content={() => componentRef.current}
                                                                documentTitle="ViolationLog"


                                                            /> */}
                                                        </ButtonGroup>
                                                        {/* <UncontrolledTooltip placement="top" target="print-tooltip">
                                                            This will open a print page with the visible rows of the
                                                            table.
                                                        </UncontrolledTooltip> */}
                                                        <UncontrolledTooltip placement="top" target="copy-tooltip">
                                                            This will copy to your clipboard the visible rows of the
                                                            table.
                                                        </UncontrolledTooltip>
                                                        <UncontrolledTooltip placement="top" target="csv-tooltip">
                                                            This will download table data in csv file.
                                                        </UncontrolledTooltip>
                                                        <UncontrolledTooltip placement="top" target="pdf-tooltip">
                                                            This will download table data in pdf file.
                                                        </UncontrolledTooltip>
                                                    </Col>
                                                    <Col xs={12} sm={4}>
                    {isLoading ? (
  <Row>
    <div className="col-sm-1">
    <Spinner /*type="grow" color="primary"*/ style={{ width: '1.75rem', height: '1.75rem' }}>
    </Spinner>
    </div>
    <div className="col-sm-11">
    <h4>Loading Data Please Wait....</h4>

    </div>
    
   
   
     </Row>
  
):(<div>
</div>)}
</Col>
                                                    <Col xs={12} sm={4}>
                                                        <div
                                                            id="datatable-basic_filter"
                                                            className="dataTables_filter px-4 pb-1 float-right"
                                                        >
                                                            <label>
                                                                <SearchBar
                                                                    className="form-control-sm"
                                                                    placeholder=""
                                                                    {...props.searchProps}
                                                                />
                                                            </label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <BootstrapTable id="react-bs-table"
                                                    ref={componentRef}
                                                    {...props.baseProps}
                                                    // bootstrap4={true}
                                                    // defaultSorted={defaultSorted}
                                                    pagination={custompagination} />

                                            </div>
                                        )
                                    }
                                </ToolkitProvider>
                            </div>
                        </CardBody>

                    </Card>
                </Col>
            </Row>
            <Row>
            </Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(ViolationsReport);
